/**
 * Nests rush-fee rows under their parent product in the cart drawer.
 * Runs after section HTML updates when Liquid grouping did not apply.
 */
function epkGroupCartDrawerItems() {
  const tbody = document.querySelector('.epk-cart-drawer .drawer__cart-items-wrapper tbody');
  if (!tbody) return;

  // Unified bundle cards hide linked lines in Liquid; DOM reordering would surface split rows.
  if (tbody.querySelector('.cart-item--epk-order-bundle')) return;

  const rows = Array.from(tbody.querySelectorAll('tr.cart-item'));
  if (!rows.length) return;

  const products = [];
  const rushLines = [];

  rows.forEach((row) => {
    const lineIndex = parseInt(row.dataset.epkLineIndex || '0', 10);
    const priceCents = parseInt(row.dataset.epkLinePrice || '0', 10);
    const isRush = row.dataset.epkIsRush === 'true';
    const baseOrderCents = parseInt(row.dataset.epkBaseOrderCents || '0', 10);

    if (isRush) {
      rushLines.push({ row, lineIndex, baseOrderCents });
      return;
    }

    products.push({ row, lineIndex, priceCents });
  });

  rushLines.forEach(({ row, lineIndex, baseOrderCents }) => {
    if (row.classList.contains('cart-item--epk-child') && row.previousElementSibling?.classList.contains('cart-item')) {
      return;
    }

    let parent =
      products.find((p) => baseOrderCents > 0 && p.priceCents === baseOrderCents && p.lineIndex !== lineIndex) ||
      products.find((p) => Math.abs(p.lineIndex - lineIndex) === 1) ||
      null;

    if (!parent) return;

    row.classList.add('cart-item--epk-child');
    parent.row.classList.add('cart-item--has-children');
    parent.row.insertAdjacentElement('afterend', row);
  });
}

function epkScheduleCartDrawerGrouping() {
  requestAnimationFrame(() => {
    epkGroupCartDrawerItems();
  });
}

document.addEventListener('DOMContentLoaded', epkScheduleCartDrawerGrouping);
document.addEventListener('cart-drawer:open', epkScheduleCartDrawerGrouping);
document.addEventListener('cart:updated', epkScheduleCartDrawerGrouping);
